import './App.css';
import Contacts from './components/Contacts';
import Footer from './components/Footer';
import Header from './components/Header';
import Hero from './components/Hero';
import Projects from './components/Projects';
import Techstack from './components/Techstack';

function App() {
  return (
    
    <div>
      <Header/>
      <Hero/>
      <Projects/>
      <Techstack/>
      <Contacts/>
      <Footer/>
    </div>
  );
}

export default App;
